var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomeContentLayout',[_c('div',{staticClass:"test"},[_vm._v("这是工作台")])])}
var staticRenderFns = []

export { render, staticRenderFns }